import {
    Form, FormButton, FormButtonContainer, FormItem, FormSubmitHandler, TextInput, isMobileView, useAlerts, useForm
} from "@sis/react-library"
import { UserDto } from './FormSamplesBasicPage';

/////////////////////////////////////////////////////////////////////////////////////////////
// Make sure your main App component is wrapped in a SisLibraryProviders context
/////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////
// The interface below is what the form will be using.
// - Even though it's using the same fields as interface UserDTO, it's better to still
//   create a new interface with a single letter and extend the existing interface.
//   This will ensure that:
//   - Later you can extend just the form interface if you need to without changing the
//     original interface.
//   - Having the interface defined as a single letter (like T) makes the code easier to read.
//   - If copying and pasting code from another component typescript will ensure you change
//     the fieldname if the copying field isn't defined in this components
//     interface you are extending.
// - The input and output of the form will use this interface fields
// - It ensures that the FormField attribute on the FormItem component has no spelling errors
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends UserDto { }

interface FormSamplesBasicFormProps {
    onSubmit: FormSubmitHandler<UserDto>;
    submitting: boolean;
}

export const FormSamplesBasicForm = ({
    onSubmit, submitting
}: FormSamplesBasicFormProps) => {

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // No need to use state at all in this component, 
    // and the controls (TextInput for example) doesn't need to add onClick or set the value.
    // This is all done internally within the form components removing boilder plate code
    //////////////////////////////////////////////////////////////////////////////////////////////////    

    //////////////////////////////////////////////////////////////////////////////////////////////////
    // The context provider holds information for multiple forms, so a form name needs to be specified
    // and it needs to be unique
    //////////////////////////////////////////////////////////////////////////////////////////////////
    const formName = 'FormBasic';

    const { resetForm } = useForm<T>(formName);
    const isMobile = isMobileView();
    const { confirm } = useAlerts();

    const handleCancel = () => {
        confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
            () => { resetForm() },
            "Yes", "No"
        );
    }

    return (
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // If you don't want the fields disabled while submitting then add a dontDisableFieldsWhileSubmitting prop
            // uncomment line below
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //dontDisableFieldsWhileSubmitting
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // If you don't set the beforeLeaveText below then you won't get prompted if changes were made when you leave
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            beforeLeaveText='You have made changes, are you sure you want to leave ?'
        >
            <FormItem<T>
                formField="firstName"  // This is validated against the interface (makes sure there's no spelling or case errors)
                label="First Name"
                // You can set autofocus on a field as well, the example below does autofocus only on 
                // desktop as on mobile the keyboard opening up straight away looks strange to me.
                // The TextInput accepts any MUI TextFieldProps Props
                element={<TextInput maxLength={20} autoFocus={!isMobile} />}
            />
            <FormItem<T>
                formField="lastName"
                label="Last Name"
                element={<TextInput maxLength={20} />}
            />
            <FormButtonContainer>
                <FormButton
                    formButtonText='Cancel'
                    // Uncomment below if you want the cancel button to always be enabled, even if no changes have been made
                    // enabledOnPristine
                    onClick={() => { handleCancel() }}
                />
                <FormButton
                    // Uncomment if you wish to show a tooltip as well
                    // tooltip="Click to submit form"
                    formButtonText='Submit'
                    submitButton
                />
            </FormButtonContainer>
        </Form>        
    )
}
